import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lyra_asset = _resolveComponent("lyra-asset")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["hd-toggle", `hd-toggle--${_ctx.modifier}`])
  }, [
    (_ctx.label !== '')
      ? (_openBlock(), _createBlock(_component_lyra_asset, {
          key: 0,
          class: "hd-toggle__label",
          "asset-key": _ctx.label
        }, null, 8, ["asset-key"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["hd-toggle__container crux-click", { 'is-active': _ctx.checkDotPosition(_ctx.itemActive) }]),
      "data-crux": "toggle",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleItem()))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["hd-toggle__dot", { 'is-active': _ctx.checkDotPosition(_ctx.itemActive) }])
      }, null, 2),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
        return (_openBlock(), _createBlock(_component_lyra_asset, {
          key: item,
          "asset-key": `toggle.item.${item}`,
          class: _normalizeClass(["hd-toggle__text", { 'is-active': item === _ctx.itemActive }])
        }, null, 8, ["asset-key", "class"]))
      }), 128))
    ], 2)
  ], 2))
}